import { render, staticRenderFns } from "./RegistrationStepper.vue?vue&type=template&id=a1b15530&scoped=true"
import script from "./RegistrationStepper.vue?vue&type=script&lang=js"
export * from "./RegistrationStepper.vue?vue&type=script&lang=js"
import style0 from "./RegistrationStepper.vue?vue&type=style&index=0&id=a1b15530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b15530",
  null
  
)

export default component.exports